"use client";

import React from "react";
import { useTheme } from "next-themes";
import Image from "next/image";
import { DictionaryProps } from "@/types";

//import LogoNight from '@/assets/images/simpleLogo.png'
//import LogoDay from '@/assets/images/simpleLogoDay.png'
import LogoNight from "@/assets/images/logoSimple.png";
import LogoDay from "@/assets/images/logoSimple.png";

interface MaintenancePageProps extends DictionaryProps {
  title?: string;
  message?: string;
  features?: string[];
  showBackButton?: boolean;
  onBack?: () => void;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({
  dict,
  title = "Funcionalidade em Desenvolvimento",
  message = "Esta página está sendo desenvolvida e estará disponível em breve. Nossa equipe está trabalhando para trazer as melhores funcionalidades para você.",
  features,
  showBackButton = false,
  onBack,
}) => {
  const { theme } = useTheme();

  const Logo = theme === "dark" ? LogoNight : LogoDay;

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        textAlign: "center",
        padding: "40px 20px",
      }}
    >
      <div style={{ marginBottom: "40px" }}>
        <Image src={Logo} alt="Striva Logo" width={150} height={60} priority />
      </div>

      <div
        style={{
          maxWidth: "600px",
          padding: "30px",
          backgroundColor: theme === "dark" ? "#2a2a2a" : "#f8f9fa",
          borderRadius: "12px",
          border: theme === "dark" ? "1px solid #404040" : "1px solid #e9ecef",
          marginBottom: "30px",
        }}
      >
        <div style={{ marginBottom: "20px", fontSize: "48px" }}>🚧</div>

        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            marginBottom: "15px",
            color: theme === "dark" ? "#ffffff" : "#333333",
          }}
        >
          {title}
        </h2>

        <p
          style={{
            fontSize: "1.1rem",
            lineHeight: "1.6",
            color: theme === "dark" ? "#cccccc" : "#666666",
            marginBottom: "20px",
          }}
        >
          {message}
        </p>

        {features && features.length > 0 && (
          <div
            style={{
              fontSize: "1rem",
              color: theme === "dark" ? "#999999" : "#888888",
            }}
          >
            {features.map((feature, index) => (
              <p key={index} style={{ margin: "8px 0" }}>
                {feature}
              </p>
            ))}
          </div>
        )}
      </div>

      {showBackButton && (
        <button
          onClick={handleBack}
          style={{
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "500",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#0056b3")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#007bff")
          }
        >
          ← Voltar
        </button>
      )}
    </div>
  );
};

export default MaintenancePage;
